import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { VariationTimelines } from "../../../../Constant";
import { UL } from "../../../../AbstractElements";
import { DynamicVariationTimeline } from "./DynamicVariationTimeline";
import { StaticVariationTimeline } from "./StaticVariationTimeline";
import { VARIATION_TIMELINE } from "../../../../Data/Bonus Ui/Timeline";

const VariationTimeline = () => {
  return (
    <Col xxl="4" xl="5" className="notification box-col-12">
      <Card>
        <CommonCardHeader title={VariationTimelines} span={VARIATION_TIMELINE} />
        <CardBody className="dark-timeline">
          <UL className="simple-list">
            <StaticVariationTimeline/>
            <DynamicVariationTimeline />
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default VariationTimeline;
